export default class FormLegacyHelper {
    public static getValidationErrors(validationState: any): any[] {
        let validationErrors: any[] = [];

        for (var propertyName in validationState) {
            if (validationState.hasOwnProperty(propertyName)) {
                for (let message of validationState[propertyName]) {
                    validationErrors.push({ name: propertyName, message: message });
                }
            }
        }

        return validationErrors;
    }

    public static isControlValidationError(controlName: string, validationErrors: any[]): boolean {
        return validationErrors.filter(x => x.name === controlName).length > 0;
    }

    public static getRequestVerificationToken(): string {
        return (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
    }

    public static showPassword(inputId: string) {
        let input: HTMLElement = document.querySelector("#" + inputId);
        input.setAttribute("type", input.getAttribute("type") === "password" ? "text" : "password");
    }

    static setFocus(contextElement: HTMLElement) {
        // Set focus on first input element
        let firstInput = contextElement.querySelector("input");
        if (firstInput) {
            firstInput.focus();
        }
    }

    static removeFocus() {
        // Remove document focus
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }

    // Legacy
    public static async setValidation(validationState) {
        if (validationState) {
            for (var field in validationState) {
                let control = document.getElementsByName(field)[0];
                if (control) {
                    control.classList.add("input-validation-error");
                }
            }
        }
    }
    
    // Legacy
    public static resetValidation() {
        let inputs = document.getElementsByClassName("input-validation-error");
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].classList.remove("input-validation-error");
        }
    }
}